import React from 'react';
import { observer } from 'mobx-react';

import DateRangePickerPopover, { formatDateRange } from '../DateRangePickerPopover';
import FilterButton from '../FilterButton';

export interface DueDateRange {
  from: number | null;
  to: number | null;
}

const DueDatePicker = ({
  value,
  onChange,
  clearable = true,
  testId,
}: {
  value: DueDateRange;
  onChange: (value: DueDateRange) => void;
  clearable?: boolean;
  testId?: string;
}): React.ReactElement => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  return (
    <>
      <FilterButton
        prefix="Due date"
        value={formatDateRange(value)}
        onClick={handleOpen}
        isOpen={open}
        testId={testId}
      />

      <DateRangePickerPopover
        open={open}
        anchorEl={anchorEl}
        value={value}
        onClose={handleClose}
        onChange={onChange}
        clearable={clearable}
      />
    </>
  );
};

export default observer(DueDatePicker);
